/**
 * Brindes da Black Friday por valor de carrinho — somente para quem veio pela UTM.
 *
 * Config: Configurações do tema > Black Friday (snippets/black-friday.liquid)
 *  - window.bfGiftRules: [{ id, threshold (centavos), cumulative }]
 *  - window.nutriageBlackFriday.utm: true quando o visitante veio pelo link da campanha
 *
 * Regra:
 *  - não cumulativo: subtotal >= threshold  -> 1 unidade
 *  - cumulativo:     1 unidade a cada threshold do subtotal (ex.: R$ 998 -> 2)
 * O subtotal desconsidera os brindes. Sem UTM (ou fora das datas), pede 0 e o
 * brinde sai do carrinho (a não ser que outra regra também peça o mesmo brinde).
 *
 * Só declara a regra; quem mexe no carrinho é o gift-sync.js.
 */
window.giftProviders = window.giftProviders || [];

window.giftProviders.push({
  name: 'bf-gifts',

  giftIds() {
    return (window.bfGiftRules || []).map((rule) => rule.id);
  },

  expected(_cartItems, { subtotal }) {
    const expected = new Map();
    const active = Boolean(window.nutriageBlackFriday && window.nutriageBlackFriday.utm);

    for (const rule of window.bfGiftRules || []) {
      let quantity = 0;
      if (active && subtotal >= rule.threshold) {
        quantity = rule.cumulative ? Math.floor(subtotal / rule.threshold) : 1;
      }
      expected.set(rule.id, (expected.get(rule.id) || 0) + quantity);
    }

    return expected;
  },
});
